export const isUrl = (route: string) => route.startsWith("http");
